import { IShiftMatchExceptionDTO } from 'src/api/dtos';
import { DurationFormatEnums, ExceptionsAmountTypeEnums } from 'src/shared/enums';
import { formatDuration } from 'src/shared/utils';

export const formatExceptionAmount = (
  exception: IShiftMatchExceptionDTO,
  durationFormat: DurationFormatEnums,
): string => {
  // format duration in seconds based on user preferences if amount type is IN_SECONDS
  return exception.amountType === ExceptionsAmountTypeEnums.IN_SECONDS && !!exception.amountInSeconds
    ? `[${formatDuration(Math.abs(exception.amountInSeconds), durationFormat, 'seconds')}]`
    : exception.amount ?? '';
};
